import NotificationChannel from "./NotificationChannel";
import NotificationChannelHttpMethod from "./NotificationChannelHttpMethod";
import NotificationChannelHttpAuthenticationConfig from "./NotificationChannelHttpAuthenticationConfig"
import NotificationChannelHttpAuthenticationType from "./NotificationChannelHttpAuthenticationType";
import CustomHeader from "./CustomHeader";

export default class NotificationChannelHttp extends NotificationChannel {
  public address: string;
  public httpMethod: string = NotificationChannelHttpMethod.POST;
  public customHeadersList: CustomHeader[]; // list of objects instead of Map<string, string> for EditableList
  public customHeaders: any;
  public authenticationType: string = NotificationChannelHttpAuthenticationType.NONE.id;
  public authenticationConfig: NotificationChannelHttpAuthenticationConfig;
  
  constructor() {
    super();
    this.channelTypeId = 'HTTP';
    this.customHeadersList = [];
    this.customHeaders = {};
    this.authenticationConfig = new NotificationChannelHttpAuthenticationConfig();
  }
}


// WEBPACK FOOTER //
// ./src/modules/organization/models/NotificationChannelHttp.ts